import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/scss/index.scss';
import App from './MacroCalculator';
//import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './styles/scss/Custom.scss'
import '../node_modules/bootstrap/dist/js/bootstrap.min.js'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
